import React from "react";
import TextField from "../molecules/TextField";
import {Grid, Typography} from "@material-ui/core";
import GenderField from "../molecules/GenderField";
import InputField from "../atoms/InputField";
import {Field} from "react-final-form";
import RenderRadioButton from "../atoms/RenderRadioButton";
import {Box, InputAdornment} from "@mui/material";
import {css} from "@emotion/react";

export const BasicInfoField = React.memo(() => {
  return (
      <>
        <Typography css={header}><span>基本情報を入力してください</span></Typography>
        <Box display={'flex'} flexWrap={'wrap'}>
          <div>
            <Grid container flexDirection={'row'} alignItems='center'>
              <Grid item flexShrink={1} css={{width: '14rem'}}>
                <InputField
                    label="身長"
                    id='base_height'
                    name='base[height]'
                    css={fieldStyle}
                    wrapperCss={{margin: '4px'}}
                    endAdornment={<InputAdornment position="end" css={adornmentStyle}>cm</InputAdornment>}
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container flexDirection={'row'} alignItems='center'>
              <Grid item flexShrink={1} css={{width: '14rem'}}>
                <InputField
                    label="体重"
                    id='base_width'
                    name='base[width]'
                    wrapperCss={{margin: '4px'}}
                    endAdornment={<InputAdornment position="end" css={adornmentStyle}>kg</InputAdornment>}
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container flexDirection={'row'} alignItems='center'>
              <Grid item flexShrink={1} css={{width: '14rem'}}>
                <InputField
                    label="年齢"
                    id='base_age'
                    name='base[age]'
                    css={fieldStyle}
                    wrapperCss={{margin: '4px'}}
                    endAdornment={<InputAdornment position="end" css={adornmentStyle}>歳</InputAdornment>}
                />
              </Grid>
            </Grid>
          </div>
        </Box>
        <Box display={'flex'}>
          <div>
            <Grid container flexDirection={'row'} alignItems='center'>
              <Grid item flexShrink={4} css={{width: '5rem', margin: '0 4px 0 2px'}}>
                <Typography><span>性別</span></Typography>
              </Grid>
              <Grid item flexShrink={1} css={{width: '20rem'}}>
                <Field
                    id="gender"
                    name="gender"
                    labels={["女性", "男性"]}
                    vals={[2, 1]}
                    defaultValue={2}
                    component={RenderRadioButton}
                />
              </Grid>
            </Grid>
          </div>
        </Box>
      </>
  )
})

BasicInfoField.displayName = 'BasicInfoField'

const header = css`
  margin: 16px 0;
  span {
    font-size: 1.4rem;
    font-weight: 500;
  }
`

const adornmentStyle = css`
  margin-right: 1rem;
`

const fieldStyle = css`
  width: 100%;
  margin-top: 6px !important;
  background-color: #0070f3;
`